<template>
	<div class="product-item-button-container">
		<button
			ref="buttonAdd2basket"
			class="product-item-button-add2cart btn btn-primary btn-icon btn-sm"
			:class="{ disabled: !canBuy }"
			@click="buy"
		>
			<svg class="icon-svg"><use :href="spritePath + '#bag'"></use></svg>
		</button>
	</div>
</template>

<script>
import FieldMixin from './FieldMixin.js';

export default {

	mixins: [FieldMixin],

	props: {
		quantity: {
			type: [ Number, String ],
			default: 1
		}
	},

	computed: {

		eventBus()
		{
			return this.$root.$eventBus || this;
		},

		inStock()
		{
			return parseFloat(this.product.inStock, 10);
		},

		isEnoughInstock()
		{
			return !this.product.checkQuantity ||
				!(this.product.checkQuantity && this.quantity > this.inStock);
		},

		canBuy()
		{
			return (this.product.canBuy && this.isEnoughInstock);
		},

		spritePath()
		{
			return B2BPortal.config.spritePath;
		},
	},

	methods: {

		buy()
		{
			if (this.canBuy)
			{
				this.eventBus.$emit('buy', {
					product: this.product.id,
					quantity: this.quantity
				});
			}
		}

	},
}
</script>